module.exports = __webpack_public_path__ + "static/img/20220119.a4087dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/20220119.jpg
// module id = bYmn
// module chunks = 98